module.exports = __webpack_public_path__ + "static/img/close-tipbutton.38d14ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-tipbutton.png
// module id = waP3
// module chunks = 0